module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Chef-f9ac7d52a9dd86e068fcaa14cc3df99d.svg";